import type { FormConfig } from './types'

const yesNo = [
  { value: 'Ja', label: { de: 'Ja', en: 'Yes' } },
  { value: 'Nein', label: { de: 'Nein', en: 'No' } },
]

export const becomePartnerForm: FormConfig = {
  id: 'becomePartner',
  submitLabel: { de: 'Abschicken', en: 'Send' },
  successMessage: {
    de: 'Vielen Dank, Ihre Anfrage wurde erfolgreich versendet.',
    en: 'Thank you, your request has been sent successfully.',
  },
  fields: [
    {
      id: 'name',
      type: 'text',
      label: { de: 'Name', en: 'Name' },
    },
    {
      id: 'instituteName',
      type: 'text',
      label: { de: 'Institutsname', en: 'Institute name' },
    },
    {
      id: 'address',
      type: 'text',
      label: { de: 'Straße und Nr', en: 'Address' },
    },
    {
      id: 'city',
      type: 'text',
      label: { de: 'PLZ und Ort', en: 'City and Zip' },
    },
    {
      id: 'email',
      type: 'email',
      label: { de: 'E-Mail-Adresse', en: 'E-Mail Address' },
      required: true,
    },
    {
      id: 'phone',
      type: 'text',
      label: { de: 'Telefonnummer', en: 'Phone' },
    },
    {
      id: 'mobile',
      type: 'text',
      label: { de: 'Mobil', en: 'Mobile' },
    },
    {
      id: 'website',
      type: 'text',
      label: { de: 'Adresse Website', en: 'Website' },
    },
    {
      id: 'usesOwnWebshop',
      type: 'text',
      label: {
        de: 'Betreiben Sie einen eigenen Online-Shop?',
        en: 'Do you use your own Online-Shop?',
      },
    },
    {
      id: 'socialMediaFacebook',
      type: 'text',
      label: { de: 'Facebook Link', en: 'Facebook link' },
    },
    {
      id: 'socialMediaInstagram',
      type: 'text',
      label: { de: 'Instagram Benutzername', en: 'Instagram username' },
    },
    {
      id: 'socialMediaTiktok',
      type: 'text',
      label: { de: 'TikTok Benutzername', en: 'TikTok username' },
    },
    {
      id: 'interestedIn',
      type: 'radio',
      label: { de: 'Ich interessiere mich für', en: "I'm interested in" },
      options: [
        {
          value: 'Dekorative Kosmetik',
          label: { de: 'Dekorative Kosmetik', en: 'Deco' },
        },
        {
          value: 'Pflegende Kosmetik',
          label: { de: 'Pflegende Kosmetik', en: 'Care' },
        },
        {
          value: 'Dekorative & Pflege',
          label: { de: 'Dekorative & Pflege', en: 'Deco & Care' },
        },
      ],
    },
    {
      id: 'currentSituation',
      type: 'radio',
      label: { de: 'Aktuelle Situation', en: 'Current situation' },
      options: [
        { value: 'in Ausbildung', label: { de: 'in Ausbildung', en: 'Student' } },
        { value: 'Gründer', label: { de: 'Gründer', en: 'Founder' } },
        {
          value: 'Bestehendes Institut',
          label: { de: 'Bestehendes Institut', en: 'Existing Institution' },
        },
        { value: 'Sonstiges', label: { de: 'Sonstiges', en: 'Other' } },
      ],
    },
    {
      id: 'education',
      type: 'text',
      label: {
        de: 'Welche Ausbildung haben Sie absolviert und wo?',
        en: 'What kind of education do you have and where did you get it?',
      },
    },
    {
      id: 'selfEmployedSince',
      type: 'text',
      label: {
        de: 'Seit wann arbeiten Sie selbständig?',
        en: 'How long have you been self-employed?',
      },
    },
    {
      id: 'openingDate',
      type: 'text',
      label: { de: 'Eröffnungstermin?', en: 'Opening date?' },
    },
    {
      id: 'companyType',
      type: 'checkbox-group',
      label: { de: 'Geschäftstyp', en: 'Company type' },
      options: [
        { value: 'Kosmetikstudio', label: { de: 'Kosmetikstudio', en: 'Cosmetic studio' } },
        { value: 'Spa', label: { de: 'Spa', en: 'Spa' } },
        { value: 'Friseur', label: { de: 'Friseur', en: 'Hairdresser' } },
        { value: 'Nagelstudio', label: { de: 'Nagelstudio', en: 'Nail salon' } },
        { value: 'Apotheke', label: { de: 'Apotheke', en: 'Pharmacy' } },
        { value: 'Mobiles Geschäft', label: { de: 'Mobiles Geschäft', en: 'Mobile shop' } },
        { value: 'Sonstiges', label: { de: 'Sonstiges', en: 'Other' } },
      ],
    },
    {
      id: 'companyLocation',
      type: 'radio',
      label: { de: 'Lage des Geschäfts', en: 'Location of company' },
      options: [
        { value: 'Stadtmitte', label: { de: 'Stadtmitte', en: 'City centre' } },
        { value: 'Stadtrand', label: { de: 'Stadtrand', en: 'Suburban' } },
        { value: 'Ländliches Gebiet', label: { de: 'Ländliches Gebiet', en: 'Rural area' } },
        { value: 'Sonstiges', label: { de: 'Sonstiges', en: 'Other' } },
      ],
    },
    {
      id: 'homeCompany',
      type: 'radio',
      label: {
        de: 'Ladengeschäft oder Studio im eigenen Haus?',
        en: 'Store or studio in own home?',
      },
      options: yesNo,
    },
    {
      id: 'propertySize',
      type: 'text',
      label: {
        de: 'Größe des Geschäfts in Quadratmetern',
        en: 'Size of property in square meters',
      },
    },
    {
      id: 'hasDisplayWindow',
      type: 'radio',
      label: { de: 'Haben Sie Schaufenster?', en: 'Do you have a display window?' },
      options: yesNo,
    },
    {
      id: 'numberOfEmployees',
      type: 'text',
      label: { de: 'Anzahl der Mitarbeiter', en: 'Number of employees' },
    },
    {
      id: 'numberOfCabins',
      type: 'text',
      label: { de: 'Anzahl der Kabinen', en: 'Number of cabins' },
    },
    {
      id: 'brandsWorkingWith',
      type: 'text',
      label: { de: 'Mit welchen Marken arbeiten Sie?', en: 'Which brands are you working with?' },
    },
    {
      id: 'clientele',
      type: 'text',
      label: { de: 'Wo sehen Sie Ihr Kundenklientel?', en: 'Where do you see your clientele?' },
    },
    {
      id: 'veganCosmeticInterest',
      type: 'text',
      label: {
        de: 'Besteht Interesse an veganer Kosmetik?',
        en: 'Is there an interest in vegan cosmetic?',
      },
    },
    {
      id: 'trainingPreference',
      type: 'radio',
      label: {
        de: 'Bevorzugen Sie Schulungen Online oder in Präsenz?',
        en: 'Do you prefer training online or in person?',
      },
      options: [
        { value: 'Online', label: { de: 'Online', en: 'Online' } },
        { value: 'in Präsenz', label: { de: 'in Präsenz', en: 'in person' } },
      ],
    },
    {
      id: 'advertisingMaterials',
      type: 'text',
      label: {
        de: 'Welche Werbemittel benötigen Sie?',
        en: 'Which advertising materials do you need?',
      },
    },
    {
      id: 'newsletter',
      type: 'radio',
      label: {
        de: 'Möchten Sie unseren Newsletter abonnieren?',
        en: 'Do you wish to subscribe to our newsletter?',
      },
      options: yesNo,
    },
    {
      id: 'visitsFairs',
      type: 'radio',
      label: { de: 'Besuchen Sie Messen?', en: 'Do you visit fairs?' },
      options: yesNo,
    },
    {
      id: 'howDidYouHearAboutUs',
      type: 'checkbox-group',
      label: {
        de: 'Wie sind Sie auf uns aufmerksam geworden?',
        en: 'How did you hear about us?',
      },
      options: [
        { value: 'Messe', label: { de: 'Messe', en: 'Fair' } },
        { value: 'Fachzeitschrift', label: { de: 'Fachzeitschrift', en: 'Journal' } },
        { value: 'Internet', label: { de: 'Internet', en: 'Internet' } },
        {
          value: 'Bereits mit MALU WILZ gearbeitet',
          label: { de: 'Bereits mit MALU WILZ gearbeitet', en: 'Already worked with MALU WILZ' },
        },
        { value: 'Empfehlung', label: { de: 'Empfehlung', en: 'Recommendation' } },
        { value: 'Ausbildung', label: { de: 'Ausbildung', en: 'Education' } },
        { value: 'Sonstiges', label: { de: 'Sonstiges', en: 'Other' } },
      ],
    },
    {
      id: 'messageToUs',
      type: 'textarea',
      label: { de: 'Ihre Mitteilung an uns', en: 'Your message to us' },
      required: true,
    },
  ],
  consentField: {
    id: 'agreeWithPersonalDataProcessing',
    type: 'checkbox',
    required: true,
    label: {
      de: 'Ich bin mit der Speicherung und Verarbeitung der hier angegebenen personenbezogenen Daten einverstanden. Die Daten werden allein zum Zwecke der Kontaktaufnahme durch Mitarbeiter der "MALU WILZ Beaute GmbH" auf Grundlage unserer Datenschutzerklärung erhoben.',
      en: 'I agree to the storage and processing of the personal data given here. The data is collected solely for the purpose of establishing contact by employees of "MALU WILZ Beaute GmbH" on the basis of our data protection declaration.',
    },
  },
}
